import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=2926344e&scoped=true&"
var script = {}
import style0 from "./contact.vue?vue&type=style&index=0&id=2926344e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926344e",
  null
  
)

export default component.exports